import { Injectable } from '@angular/core';
import { GetTotalInput, Total, Totals } from 'models';
import { Subject } from 'rxjs';
import { ApiService } from 'src/_utility/api';
import { StorageService } from './storage.service';

type TotalType = ('answers' | 'companies');

@Injectable({
  providedIn: 'root'
})
export class TotalsService {

  private answerTotals: Totals = undefined;
  private companyTotals: Totals = undefined;
  totalsOnLoaded: Subject<Totals> = new Subject();

  constructor(
    private api: ApiService,
    private storage: StorageService
  ) { }

  loadTotals(input: GetTotalInput, callBack: () => void = null) {
    this.api.postTotals(input)
      .then(data => {
        if (data) {
          this.companyTotals = this.companyTotals ? this.companyTotals : data.Societies.map(x => Total.mapData(x));

          this.answerTotals = data.Questions.reduce((t, q) => {
            const tAnswers = q.Answers.map(a => Total.mapData(a));
            t = t.concat(tAnswers);
            return t
          }, []);

          const totalProducts = this.getTotal('1.0')?.quantity ?? undefined;
          this.storage.setTotalProducts(totalProducts)
        }
        else { this.storage.setTotalProducts(0); }
        this.totalsOnLoaded.next(this.answerTotals);
        if (callBack != null) callBack();
      })
      .catch(err => {
        this.answerTotals = undefined;
        this.storage.setTotalProducts(0);
        this.totalsOnLoaded.next(this.answerTotals);
        if (callBack != null) callBack();
      })
  }

  resetTotals() {
    this.answerTotals = undefined;
    this.totalsOnLoaded.next(this.answerTotals);
  }

  getTotals(totalsOf: TotalType = 'answers'): Totals {
    return totalsOf == 'companies' ? this.companyTotals : this.answerTotals
  }

  getTotal(fId: string, totalOf: TotalType = 'answers'): Total {
    const items: Total[] = this.getTotals(totalOf)
    return items?.find(x => x.id == fId)
  }
}
